import { CenterBox } from '@repo/ui/components/center-box'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import Image from 'next/image'
import { ButtonLink } from '@repo/shared/index'

export const BalanceProjectTransferEmptyState = () => {
  const { t } = useTranslate()

  return (
    <CenterBox className=' flex-col gap-lg py-10xl'>
      <Image src='/images/alarm.webp' alt='coin' width={64} height={64} />

      <Typography
        variant='p'
        size='sm'
        color='text-base-surface-100'
        className='text-center'
      >
        {t('balanceProjectTransferEmptyState_title')}
      </Typography>
      <ButtonLink variant='fill' color='base' size='sm' href='/wallet/transfer'>
        {t('balanceProjectTransferEmptyState_cta')}
      </ButtonLink>
    </CenterBox>
  )
}
